<template>
    <action-button
        :icon="icon"
        :label="label"
        @click="$emit('click', $event)"
        :to="to"
        :disabled="disabled"
    />
</template>

<script>
import i18n from '@/plugins/i18n'
import ActionButton from './ActionButton'
export default {
    props: {
        to: {
            required: true,
        },
        disabled: {
            default: false,
        },
    },

    components: {
        ActionButton,
    },

    computed: {
        icon() {
            return 'mdi-pencil'
        },

        label() {
            return i18n.t('resources.actions.edit')
        },
    },
}
</script>

<style></style>
